var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Component, PropSync, Ref, Vue } from 'vue-property-decorator';
import { Group } from '@/models/Group';
import DataTable from '@/components/data-table/DataTable';
import StudentSnackbar from '@/components/StudentSnackbar/StudentSnackbar.vue';
import { RolesEnum } from '@/items/Roles';
import StudentSelect from '@/components/StudentSelect/StudentSelect.vue';
import AStudentTable from '@/components/AStudentTable/AStudentTable.vue';
// Dialogs
import TreatmentDialog from '@/views/Curricula/TreatmentDialog';
import ChangeLevelAndPeriodDialog from '@/views/Groups/Tabs/StudentList/Dialogs/ChangeLevelAndPeriodDialog/ChangeLevelAndPeriodDialog.vue';
import AssignGraduationProfileDialog from '@/views/Groups/Tabs/StudentList/Dialogs/AssignGraduationProfileDialog/AssignGraduationProfileDialog.vue';
import AssignGoalSetDialog from '@/views/Groups/Tabs/StudentList/Dialogs/AssignGoalSetDialog/AssignGoalSetDialog.vue';
import AssignSkillSetDialog from '@/views/Groups/Tabs/StudentList/Dialogs/AssignSkillSetDialog/AssignSkillSetDialog.vue';
let StudentList = class StudentList extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region Class properties
        this.forceCloseSnackbar = false;
        this.selectedStudents = [];
        this.isChangingLevelAndPeriod = false;
        this.isAssigningGraduationProfile = false;
        this.isAssigningGoalSet = false;
        this.isAssigningSkillSet = false;
        this.RolesEnum = RolesEnum;
        this.selectedUsers = [];
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    // #endregion
    // #region Event handlers
    onTableInput(value) {
        this.selectedStudents = value;
    }
    onClickOpenAssignGraduationProfileDialog() {
        this.isAssigningGraduationProfile = true;
    }
    onCloseChangeLevelAndPeriodDialog() {
        this.isChangingLevelAndPeriod = false;
        this.forceCloseSnackbar = false;
    }
    onChangeLevelAndPeriodSubmitted() {
        this.clearSelectedStudents();
        this.forceCloseSnackbar = false;
        this.isChangingLevelAndPeriod = false;
        this.$nextTick(() => {
            this.$store.dispatch('openDialog', this.changeLevelAndPeriodSuccessDialogOptions);
        });
    }
    onCloseAssignGraduationProfileDialog() {
        this.isAssigningGraduationProfile = false;
        this.forceCloseSnackbar = false;
    }
    onCloseAssignGoalSetDialog() {
        this.isAssigningGoalSet = false;
        this.forceCloseSnackbar = false;
    }
    onCloseAssignSkillSetDialog() {
        this.isAssigningSkillSet = false;
        this.forceCloseSnackbar = false;
    }
    // #endregion
    // #region Class methods
    clearSelectedStudents() {
        this.selectedStudents = [];
        this.aStudentTable.clearSelectedStudents();
    }
    // #endregion
    // #region Async methods (api calls only)
    // #endregion
    // #region Getters & Setters
    get hasSelectedStudents() {
        return this.selectedStudents.length > 0;
    }
    get snackbarActions() {
        return [
            {
                icon: 'school',
                click: () => {
                    this.isAssigningGraduationProfile = true;
                    this.forceCloseSnackbar = true;
                },
                label: this.$tc('Manage graduation profiles'),
            },
            {
                icon: 'equalizer',
                click: () => {
                    this.isChangingLevelAndPeriod = true;
                    this.forceCloseSnackbar = true;
                },
                label: this.$tc('Manage level and period'),
            },
            {
                icon: 'flag',
                click: () => {
                    this.isAssigningGoalSet = true;
                    this.forceCloseSnackbar = true;
                },
                label: this.$tc('Manage goal sets'),
            },
            {
                icon: 'psychology',
                click: () => {
                    this.isAssigningSkillSet = true;
                    this.forceCloseSnackbar = true;
                },
                label: this.$tc('Manage skill sets'),
            },
            {
                icon: 'do_not_disturb_on',
                click: () => {
                    this.clearSelectedStudents();
                },
                label: this.$tc('snackbar.actions.deselect'),
            },
        ];
    }
    get snackbarCount() {
        let count = 0;
        if (this.selectedStudents.length > 0) {
            count = this.selectedStudents.length;
        }
        return count;
    }
    get changeLevelAndPeriodSuccessDialogOptions() {
        return {
            title: this.$tc('Action completed'),
            text: this.$tc('The levels and/or periods have successfully been updated.'),
            type: 'success',
            buttons: {
                confirm: {
                    text: this.$tc('dialogOptions.button.ok'),
                },
            },
        };
    }
};
__decorate([
    PropSync('group'),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], StudentList.prototype, "syncedGroup", void 0);
__decorate([
    Ref(),
    __metadata("design:type", typeof (_b = typeof AStudentTable !== "undefined" && AStudentTable) === "function" ? _b : Object)
], StudentList.prototype, "aStudentTable", void 0);
StudentList = __decorate([
    Component({
        components: {
            DataTable,
            TreatmentDialog,
            StudentSnackbar,
            ChangeLevelAndPeriodDialog,
            AssignGraduationProfileDialog,
            AssignGoalSetDialog,
            AssignSkillSetDialog,
            StudentSelect,
            AStudentTable,
        },
    })
], StudentList);
export default StudentList;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
